module.exports = __webpack_public_path__ + "img/6_newYouth_jbb.afea32dc.png";